import { Modal } from '@material-ui/core';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import getStringsBasedLang from '../../strings/get_strings'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from 'antd';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        /*   width: 400, */
        backgroundColor: "#ffffff",
        border: 0,
        boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
        padding: theme.spacing(2, 4, 3),
        left: "50%",
        top: "50%",
        outline: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
        [theme.breakpoints.down('xs')]: {
            width: 280,
            padding: 10
        },
    },
    border: {
        border: 'solid 1px #E0E0E0',
    },
    border_bottom: {
        borderBottom: 'solid 1px #E0E0E0'
    }
}))

let promiseInfo = {};
const ConfirmScanModal = forwardRef((props, ref) => {

    const [show, setShow] = useState(false)
    const classes = useStyles()

    useImperativeHandle(ref, () => ({
        showModal: async () => {
            return new Promise((resolve, reject) => {
                setShow(true);
                promiseInfo = {
                    resolve,
                    reject
                };
            });
        }
    }))

    const clickHandler = (txt) => {
        setShow(false)
        promiseInfo.resolve(txt)
    }

    return (
        <React.Fragment>
            <Modal
                disableScrollLock={true}
                open={show}
            /*  onClose={() => setShow(false)} */
            >
                <div className={`${classes.paper} w-1/6 xs:w-5/6 flex flex-col text-center`}>
                    <div className='flex flex-col items-center'>
                        <span className='primary_text_color font-bold'>{getStringsBasedLang("scanned_before_1")}</span>
                        <span className='primary_text_color font-bold'>{getStringsBasedLang("scanned_before_2")}</span>
                    </div>
                    <div className='flex items-center justify-center mt-5'>
                        <Button type='default' onClick={() => clickHandler('yes')}>{getStringsBasedLang("general_yes")}</Button>
                        <Button className='mx-2' type='primary' onClick={() => clickHandler('no')}>{getStringsBasedLang("general_no")}</Button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
})

export default ConfirmScanModal